import Vue from 'vue';

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import VueResource from 'vue-resource';
Vue.use(VueResource);

import VueRouter from 'vue-router';
Vue.use(VueRouter);

import 'bootstrap/dist/css/bootstrap.css';

import './assets/fonts/stylesheet.css';

import App from './App.vue';

new Vue({
  el: '#app',
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js